// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3q69r","right":"styles_right__2sl3U"};